import React from "react";

function Upnext({ upNext }) {
  const waitingList = upNext.filter((next) => next.status === "waiting");
  const visibleItems = waitingList.slice(0, 10);
  const hasMore = waitingList.length > 10;

  return (
    <div className="ps-3">
      <h5 className="fw-bold mb-2" style={{ color: "grey" }}>
        Up Next
      </h5>
      <hr></hr>
      <div className="row g-1 mb-2 d-flex align-items-stretch">
        {visibleItems.map((item, idx) => (
          <div className="col-auto" key={idx}>
            <div
              className="card text-center shadow-sm p-1 h-100"
              style={{
                width: "105px",
                borderRadius: "6px",
                fontSize: "0.65rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div className="card-body py-1 px-1">
                <p
                  className="fw-bold text-dark mb-1"
                  style={{
                    lineHeight: "0.8rem",
                    fontSize: "0.7rem",
                  }}
                >
                  {item?.name}
                </p>
                <hr
                  style={{
                    margin: "2px 0",
                    borderTop: "1.5px solid #f2c59c",
                  }}
                />
                <p
                  className="card-text text-muted"
                  style={{ fontSize: "0.5rem", marginBottom: 0 }}
                >
                  {item?.positionApplied}
                </p>
              </div>
            </div>
          </div>
        ))}

        {hasMore && (
          <div className="col-auto">
            <div
              className="card text-center shadow-sm p-1 h-100 d-flex align-items-center justify-content-center"
              style={{
                width: "100px",
                height: "100%",
                borderRadius: "6px",
                fontSize: "1.25rem",
                fontWeight: "bold",
                color: "#aaa",
              }}
            >
              ...
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Upnext;
